import { Translations } from '@fe/translations';

export const DEFAULT_CTRL_MESSAGE_TRANSLATIONS: Translations = {
  required: `Value is required`,
  zipCodeFormat: 'Zip Code is invalid',
  phoneNumberFormat: 'Phone Number is invalid'
};
